import React, { Fragment, useState, useEffect } from "react";
import "../../styles/dashboard.css";
import "../../styles/left-menu.css";
import "../../styles/farm.css";
import "../../styles/records.css";
import "../../styles/modal.css";


import { Outlet } from "react-router-dom";
import LeftMenu from "./left-menu.jsx";
import LeftMenuMobile from "./left-menu-mobile.jsx"
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';


const Layout = () => {
    const navigate = useNavigate();
    const [isBtn, setIsBtn] = useState(false);
    const [showMenu, setShowMenu] = useState(false);

    useEffect(() => {

        if (localStorage.getItem('@email') == null || !localStorage.getItem('@email'))
            navigate("/login");


    }, []);


    const handleLogout = async () => {

        await axios.post(process.env.REACT_APP_API_URL + "/logout", {
            email: localStorage.getItem('@email')
        })
            .then(function (response) {
                setIsBtn(false)
                if (response?.data?.status) {

                    localStorage.removeItem("@email");
                    localStorage.removeItem('@roampays-user');
                    navigate("/login");


                } else {

                    Swal.fire({ icon: "error", title: "Logout Failed", text: response?.data?.message });

                }
            })
            .catch(function (error) {
                navigate("/login");

            });


    };


    return (
        <Fragment>
            <section className="dashboard" >
                <section className="dashboard-left" >


                    <div className="menu">

                        <div className="logo color-white">
                            <h3 >
                            <svg xmlns="http://www.w3.org/2000/svg" width="100" height="21" viewBox="0 0 100 21" fill="none">
  <path d="M0 20.5486V0H14.3412C16.1008 0 17.6112 0.256324 18.8725 0.768972C20.1339 1.28162 21.0985 2.01262 21.7662 2.96197C22.434 3.91132 22.7679 5.04104 22.7679 6.35114V6.37962C22.7679 7.85111 22.3333 9.10425 21.4641 10.139C20.6056 11.1738 19.376 11.9096 17.7755 12.3463L23.547 20.5486H18.491L13.3078 12.9301C13.2654 12.9301 13.223 12.9301 13.1806 12.9301C13.1488 12.9301 13.1117 12.9301 13.0693 12.9301H4.38822V20.5486H0ZM4.38822 9.99664H13.9914C15.3694 9.99664 16.4346 9.69285 17.1872 9.08526C17.9504 8.47768 18.332 7.61852 18.332 6.50778V6.4793C18.332 5.40654 17.9398 4.56637 17.1554 3.95878C16.371 3.3512 15.2899 3.04741 13.9119 3.04741H4.38822V9.99664Z" fill="white"/>
  <path d="M35.0982 20.8904C33.0206 20.8904 31.1975 20.5724 29.6288 19.9363C28.0706 19.2908 26.857 18.3841 25.9878 17.2164C25.1187 16.0392 24.6841 14.6484 24.6841 13.044V13.0156C24.6841 11.4112 25.1187 10.0251 25.9878 8.85742C26.8676 7.68023 28.0865 6.7736 29.6447 6.13754C31.2134 5.49198 33.0312 5.1692 35.0982 5.1692C37.1757 5.1692 38.9988 5.49198 40.5675 6.13754C42.1363 6.7736 43.3552 7.68023 44.2244 8.85742C45.0936 10.0251 45.5281 11.4112 45.5281 13.0156V13.044C45.5281 14.6484 45.0936 16.0392 44.2244 17.2164C43.3552 18.3841 42.1363 19.2908 40.5675 19.9363C39.0094 20.5724 37.1863 20.8904 35.0982 20.8904ZM35.1141 17.9996C36.3224 17.9996 37.3824 17.805 38.2939 17.4158C39.2161 17.0266 39.9316 16.4664 40.4403 15.7354C40.9597 14.995 41.2194 14.0978 41.2194 13.044V13.0156C41.2194 11.9618 40.9597 11.0694 40.4403 10.3384C39.9316 9.59791 39.2161 9.03305 38.2939 8.64382C37.3718 8.25458 36.3065 8.05997 35.0982 8.05997C33.9004 8.05997 32.8405 8.25458 31.9183 8.64382C31.0067 9.03305 30.2913 9.59791 29.7719 10.3384C29.2525 11.0694 28.9928 11.9618 28.9928 13.0156V13.044C28.9928 14.0978 29.2472 14.995 29.756 15.7354C30.2754 16.4664 30.9961 17.0266 31.9183 17.4158C32.8405 17.805 33.9057 17.9996 35.1141 17.9996Z" fill="white"/>
  <path d="M54.599 20.8192C53.1045 20.8192 51.8008 20.6388 50.6878 20.2781C49.5748 19.9173 48.711 19.3904 48.0962 18.6974C47.492 17.9949 47.1899 17.1357 47.1899 16.1199V16.1057C47.1899 15.2418 47.4337 14.4871 47.9213 13.8415C48.4089 13.1959 49.1774 12.688 50.2267 12.3178C51.2867 11.9475 52.654 11.7434 54.3288 11.7055L63.9638 11.5346V13.7988L54.917 13.9981C53.6769 14.0266 52.7759 14.2117 52.2141 14.5535C51.663 14.8953 51.3874 15.3557 51.3874 15.9348V15.9633C51.3874 16.7038 51.7743 17.2592 52.548 17.6294C53.3324 17.9902 54.3659 18.1705 55.6484 18.1705C56.8886 18.1705 57.9697 18.0186 58.8919 17.7148C59.8246 17.4016 60.5454 16.9649 61.0542 16.4047C61.5736 15.8351 61.8333 15.1706 61.8333 14.4111V11.1074C61.8333 10.1106 61.404 9.33684 60.5454 8.78622C59.6974 8.2356 58.4838 7.96029 56.9045 7.96029C55.5265 7.96029 54.4189 8.1644 53.5815 8.57262C52.7547 8.98084 52.2353 9.53146 52.0233 10.2245L51.9757 10.3526H47.9531L47.9849 10.1818C48.1545 9.21343 48.6156 8.35427 49.3682 7.60428C50.1313 6.8448 51.1489 6.25146 52.4208 5.82425C53.7034 5.38755 55.2191 5.1692 56.9681 5.1692C58.876 5.1692 60.5083 5.40179 61.8651 5.86697C63.2218 6.33215 64.2606 6.9967 64.9813 7.86061C65.7021 8.72451 66.0625 9.7593 66.0625 10.965V20.5486H61.8333V17.9427H61.7538C61.3616 18.5313 60.8104 19.0439 60.1002 19.4806C59.3901 19.9078 58.5686 20.2401 57.6358 20.4774C56.7031 20.7053 55.6908 20.8192 54.599 20.8192Z" fill="white"/>
  <path d="M69.0121 20.5486V5.51097H73.2414V8.40173H73.3209C73.8826 7.35745 74.7094 6.56 75.8012 6.00938C76.9035 5.44926 78.1808 5.1692 79.6329 5.1692C80.6929 5.1692 81.6362 5.3116 82.463 5.59641C83.3004 5.88121 84.0105 6.29418 84.5935 6.83531C85.1765 7.36694 85.6217 8.00775 85.9291 8.75774H86.0086C86.4113 7.97927 86.9519 7.32422 87.6303 6.79259C88.3087 6.25146 89.0877 5.84799 89.9675 5.58217C90.8579 5.30686 91.8171 5.1692 92.8453 5.1692C94.3822 5.1692 95.6807 5.43977 96.7406 5.9809C97.8112 6.51253 98.6221 7.27201 99.1732 8.25933C99.7244 9.23716 100 10.4001 100 11.7482V20.5486H95.7708V12.5029C95.7708 11.5726 95.6118 10.7846 95.2938 10.139C94.9758 9.49348 94.4935 8.99982 93.8469 8.65806C93.211 8.31629 92.4054 8.14541 91.4302 8.14541C90.4127 8.14541 89.5382 8.33528 88.8068 8.71502C88.0861 9.09476 87.5296 9.63589 87.1374 10.3384C86.7558 11.0314 86.565 11.8431 86.565 12.7735V20.5486H82.4471V12.4175C82.4471 11.5251 82.2881 10.7609 81.9701 10.1248C81.6521 9.47924 81.1699 8.99033 80.5233 8.65806C79.8873 8.31629 79.087 8.14541 78.1225 8.14541C77.1155 8.14541 76.2464 8.34003 75.515 8.72926C74.7836 9.11849 74.2218 9.66437 73.8297 10.3669C73.4375 11.0599 73.2414 11.8763 73.2414 12.8162V20.5486H69.0121Z" fill="white"/>
</svg>

                            </h3>
                            <div className="menu-icon" onClick={() => setShowMenu(!showMenu)}>
                                <svg fill="#ffffff" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="20px" height="20px" viewBox="0 0 24.75 24.75" xmlSpace="preserve"><g><path d="M0,3.875c0-1.104,0.896-2,2-2h20.75c1.104,0,2,0.896,2,2s-0.896,2-2,2H2C0.896,5.875,0,4.979,0,3.875z M22.75,10.375H2	c-1.104,0-2,0.896-2,2c0,1.104,0.896,2,2,2h20.75c1.104,0,2-0.896,2-2C24.75,11.271,23.855,10.375,22.75,10.375z M22.75,18.875H2	c-1.104,0-2,0.896-2,2s0.896,2,2,2h20.75c1.104,0,2-0.896,2-2S23.855,18.875,22.75,18.875z" /></g></svg>
                            </div>
                        </div>
                        <div className={showMenu ? 'menu-list show-menu' : 'menu-list'}>
                            <LeftMenu />

                            <div className="menu-bottom">

                                <a href="#" onClick={handleLogout} className="btn-menu fs-14 color-white" disabled={isBtn}>
                                    {isBtn ? 'Signing Out...' : 'Sign Out'}</a>
                            </div>

                        </div>
                    </div>


                </section>
                <section className={showMenu ? 'dashboard-right show-mobile-menu' : 'dashboard-right'} >


                    <Outlet />

                </section>


                <section  className="dashboard-mobile-menu">

                    <LeftMenuMobile />

                </section>

            </section>
        </Fragment>
    );
};

export default Layout;
